<template>
  <el-dialog :title="title" :visible.sync="internalVisible" :width="width" :show-close='showclose' :before-close="beforeClose">
    <div style="font-size:18px">{{ message }}</div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="handleCancel">取 消</el-button> -->
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "提示"
    },
    visible: {
      type: Boolean,
      default: false
    },
    showclose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "20%"
    },
    message: String
  },
  data() {
    return {
      internalVisible: this.visible
    };
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    beforeClose(done) {
      this.$emit("before-close", done);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dialog.vue